import Web3 from 'web3'
import { coinPublicImage } from '../../assets/coins/coins'
import { Token } from '../../logic/token/token'
import { InjectedWindow } from '../../utils/types'

declare const window: InjectedWindow

export async function addToWallet(web3: Web3, token: Token, withImage:boolean): Promise<boolean> {
  const { address, symbol } = token

  if (!window.ethereum) {
    throw new Error('No window.ethereum to add to metamask')
  }
  return !!(await window.ethereum.request({
    method: 'wallet_watchAsset',
    params: {
      type: 'ERC20',
      options: {
        address: address,
        symbol: symbol,
        decimals: token.decimals,
        image:withImage? coinPublicImage(symbol):undefined,
      },
    },
  }))
}
